/**
 * Application constants
 */

// export const APP_CONFIG = {
//   NAME: process.env['REACT_APP_APP_NAME'] || 'ActivityLogs',
//   VERSION: process.env['REACT_APP_VERSION'] || '1.0.0',
//   ENV: process.env['REACT_APP_ENV'] || 'development',
//   API_BASE_URL:
//     process.env['REACT_APP_API_BASE_URL'] || 'http://localhost:5000/api',
//   LOG_LEVEL: process.env['REACT_APP_LOG_LEVEL'] || 'info',
// } as const;

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    PROFILE: '/auth/profile',
    COMPANY: '/auth/company',
  },
  ACTIVITY_LOGS: {
    LIST: '/activity-logs',
    CREATE: '/activity-logs',
    UPDATE: '/activity-logs/:id',
    DELETE: '/activity-logs/:id',
    DETAILS: '/activity-logs/:id',
  },
  AUDIT: {
    LIST: '/audit',
    EXPORT: '/audit/export',
    MODULES: '/audit/modules',
  },
} as const;

export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  ACTIVITY_LOGS: '/activity-logs',
  AUDIT: '/audit',
  PROFILE: '/profile',
} as const;

export const THEME_MODES = {
  LIGHT: 'light',
  DARK: 'dark',
} as const;

export const LOG_LEVELS = {
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info',
  DEBUG: 'debug',
} as const;
